<template>
  <div class="potential-winning mb-4">
    <v-card color="success" variant="outlined">
      <v-card-text class="text-center">
        <div class="text-caption">{{ $t('events.betting.potentialWinning') }}</div>
        <div class="text-h5 font-weight-bold"><Currency :amount="parseFloat(potentialWinning)" /></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import Currency from '@/components/Currency.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  potentialWinning: [String, Number],
})
</script>
